import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import {
  LayerEventPayload,
  LayerManagerV2,
} from '@volkswagen-onehub/layer-manager';

export function handleBodyScrollLock(layerManager: LayerManagerV2): void {
  layerManager.subscribe((payload: LayerEventPayload) => {
    switch (payload) {
      case 'afterRender':
      case 'beforeClose':
        const layers = layerManager.getLayers();
        const topLayerElement = layers[layers.length - 1]?.layer.element;

        if (topLayerElement) {
          const toggleBodyScroll =
            payload === 'beforeClose' ? enableBodyScroll : disableBodyScroll;

          toggleBodyScroll(topLayerElement);
        }
    }
  });
}
